import DetailsCard from 'components/DetailsCard';
import { getEntityTitle } from 'features/Entity/components/EntityActionBar/utils/getEntityTitle';
import AllowedMimeTypes from 'features/EntityDetails/components/EntityDetails/AllowedMimeTypes';
import EntityDetail from 'features/EntityDetails/components/EntityDetails/EntityDetail';
import useStyles from 'features/EntityDetails/components/EntityDetails/EntityDetails.styles';
import IdentifiableEntityDetail from 'features/EntityDetails/components/EntityDetails/IdentifiableEntityDetail';
import OperatingHours from 'features/EntityDetails/components/EntityDetails/OperatingHours';
import { IBaseEntity } from 'types/detailsEntityType';

type EntityDetailsCardProps = {
  entity: IBaseEntity;
  previousEntity?: IBaseEntity;
};

const EntityDetailsCard = ({ entity, previousEntity }: EntityDetailsCardProps) => {
  const classes = useStyles();

  const {
    internetAccessAvailable,
    averageWeeklyImpactsAvailable,
    planningRateCpm,
    currency,
    audienceDataSource,
    venueType,
    auctionToSpotTimeMinutes,
    allowedMimeTypes,
    operatingHours,
    entityType,
  } = entity;
  const formatMinutes = (minutes?: number | null): string | undefined =>
    typeof minutes === 'number' ? `${minutes} minutes` : undefined;

  return (
    <DetailsCard
      title={`${getEntityTitle(entityType)} DETAILS`}
      detailsRows={[
        <div className={classes.dataRow}>
          <EntityDetail
            label="Internet"
            value={internetAccessAvailable}
            previousValue={previousEntity?.internetAccessAvailable}
            layout="stacked"
          />
          <EntityDetail
            label="Avg. Weekly Impacts Available"
            value={averageWeeklyImpactsAvailable}
            previousValue={previousEntity?.averageWeeklyImpactsAvailable}
            layout="stacked"
          />
          <EntityDetail
            label="Planning Rate CPM"
            value={planningRateCpm}
            previousValue={previousEntity?.planningRateCpm}
            layout="stacked"
          />
          <EntityDetail
            label="Currency"
            value={currency}
            previousValue={previousEntity?.currency}
            layout="stacked"
          />
          <EntityDetail
            label="Audience Data Source"
            value={audienceDataSource}
            previousValue={previousEntity?.audienceDataSource}
            layout="stacked"
          />
          <IdentifiableEntityDetail
            label="Venue Type"
            entity={venueType}
            previousEntity={previousEntity?.venueType}
            layout="stacked"
          />
          <EntityDetail
            label="Auction To Spot Time"
            value={formatMinutes(auctionToSpotTimeMinutes)}
            previousValue={formatMinutes(previousEntity?.auctionToSpotTimeMinutes)}
            layout="stacked"
          />
        </div>,
        <AllowedMimeTypes
          allowedMimeTypes={allowedMimeTypes}
          previousAllowedMimeTypes={previousEntity?.allowedMimeTypes}
        />,
        <OperatingHours
          operatingHours={operatingHours}
          previousOperatingHours={previousEntity?.operatingHours}
        />,
      ]}
    />
  );
};

export default EntityDetailsCard;
